import { useEffect, useState } from 'react';
import { ApiError } from '../../../../../shared/shared.api';
import { getTrailer, type TrailerDetail } from '../trailers.api';

export type TrailerRecordState =
  { status: 'loading' } | { status: 'loaded'; trailer: TrailerDetail } | { status: 'forbidden' } | { status: 'not_found' } | { status: 'error' };

function toErrorState(err: unknown): TrailerRecordState {
  if (err instanceof ApiError && err.status === 403) return { status: 'forbidden' };
  if (err instanceof ApiError && err.status === 404) return { status: 'not_found' };
  return { status: 'error' };
}

/** One trailer, fetched by id and re-fetchable after a mutation commits. */
export function useTrailerRecord(id: string) {
  const [state, setState] = useState<TrailerRecordState>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;

    getTrailer(id)
      .then((trailer) => {
        if (!cancelled) setState({ status: 'loaded', trailer });
      })
      .catch((err) => {
        if (!cancelled) setState(toErrorState(err));
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  async function reload(): Promise<void> {
    try {
      setState({ status: 'loaded', trailer: await getTrailer(id) });
    } catch (err) {
      setState(toErrorState(err));
    }
  }

  return { state, reload };
}
